"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponents = void 0;
function registerComponents(components, context, _a) {
    var registerComponent = _a.registerComponent, registerLibrary = _a.registerLibrary;
    var library = context.library, manifest = context.manifest;
    if (Object.keys(components).length) {
        if (registerComponent) {
            Object.keys(components).forEach(function (componentName) {
                var loader = components[componentName];
                registerComponent(componentName, loader, library.artifactId);
            });
        }
        if (registerLibrary) {
            registerLibrary(library.artifactId, components, manifest.assets);
        }
    }
}
exports.registerComponents = registerComponents;
//# sourceMappingURL=registerComponents.js.map